"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidThresholdOrder = void 0;
/** isValidThresholdOrder returns ok when the warning and alert thresholds are ordered correctly for the given operator; null `warningThreshold` and the unordered `EQ`/`NEQ` operators always pass. */
const isValidThresholdOrder = (monitor) => {
    if (monitor.warningThreshold == null)
        return { valid: true };
    switch (monitor.thresholdOperator) {
        case "GT":
        case "GTE":
            if (monitor.warningThreshold < monitor.alertThreshold) {
                return { valid: true };
            }
            return {
                valid: false,
                reason: "alertThreshold must be > warningThreshold",
            };
        case "LT":
        case "LTE":
            if (monitor.warningThreshold > monitor.alertThreshold) {
                return { valid: true };
            }
            return {
                valid: false,
                reason: "alertThreshold must be < warningThreshold",
            };
        case "EQ":
        case "NEQ":
            return { valid: true };
    }
};
exports.isValidThresholdOrder = isValidThresholdOrder;
